import { Observable, of } from 'rxjs';
import { DataList, Schedule, SchedulePostRequest } from '../../../domain';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment } from 'libs/core/auth/auth.tokens';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {
  private options: Environment = inject(ENVIRONMENT);
  private baseUrlData: string;

  constructor(private http: HttpClient) {
    this.baseUrlData = `${this.options.baseUrl.data}`;
  }

  getScheduleIrrigationData(tenantId: string, sectorId: string, date: string){
    const baseUrlData = `${this.baseUrlData}/communities/${tenantId}/irrigation-schedule`;
    
    let params = new HttpParams()
    params = params.append("sectorId", sectorId);
    params = params.append("date", date);
    
    return this.http.get<DataList<Schedule>>(baseUrlData, {params})
  }
  
  saveScheduleIrrigationData(tenantId: string, sectorId: string, schedulePostData: DataList<SchedulePostRequest>) {
    const baseUrlData = `${this.baseUrlData}/communities/${tenantId}/irrigation-schedule`
    
    return this.http.post<DataList<SchedulePostRequest>>(baseUrlData, schedulePostData)
  }

}
